<template>
  <UModal
    :dismissible="false" 
    :close="{ onClick: () => emit('close') }"
    :ui="{ footer: 'justify-end' }"
  >
    <template #header>
      <VisuallyHidden>
        <DialogTitle>{{ t('components.alert_title') }}</DialogTitle>
        <DialogDescription>{{ message }}</DialogDescription>
      </VisuallyHidden>

      <UButton
        id="alertModalCloseBtn"
        :aria-label="t('components.close')"
        class="absolute top-1 end-2"
        variant="ghost"
        tabindex="-1" 
        @click="emit('close')"
      >
        <svg class="w-5 h-5">
            <use xlink:href="/icons/default-icons.svg#close" />
        </svg>
      </UButton>
    </template>

    <template #body>{{ message }}</template>

    <template #footer>
      <div v-if="buttonAction">
        <UButton 
          id="alertModalCustomCloseBtn"
          :label="t('components.close')" 
          variant="outline" 
          tabindex="-1" 
          @click="runButtonAction(buttonAction)">{{ buttonActionText || t('components.close') }}
        </UButton>
      </div>
      <div v-else />
    </template>
    
  </UModal>
</template>

<script setup lang="ts">

// Reku-UI is the underlying UI for NuxtUI. 
// This import is required to include a DialogTitle and DialogDescription element which is an accessibility requirement.
import { DialogTitle, DialogDescription, VisuallyHidden } from 'reka-ui'

const { t } = useI18n();
defineProps<{ 
  message: string,
  buttonAction?: () => void,
  buttonActionText?: string,
}>();

const emit = defineEmits([
	'close'
]);

const runButtonAction = (action: () => void) => {
  action();
  emit('close');
}

</script>
